import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "../components/layout";
// import ArticlesComponent from "../components/articles";
import "../assets/css/main.css";
import { Link } from "gatsby";
import YunJia from "../components/yunJia"
import LianXi from "../components/lianXi"

const IndexPage = () => {
  const data = useStaticQuery(query);
  const news = data.topTenNews.edges
  // console.log(news)
  return (
    <Layout seo={data.strapiHomepage.seo}>
    <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
    <tbody><tr>
      <td width="265" valign="top">
      <table width="263" border="0" cellSpacing="0" cellPadding="0" align="center">
        <tbody><tr>
          <td>&nbsp;</td>
        </tr>
              <tr>
          <td width="263" height="38" background="/images/left_bj1.gif" style={{ paddingLeft: '25px' }}>&nbsp;<span className="STYLE3">航空货运行业新闻</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="#">&gt;&gt;More</a></td>
    </tr>
        <tr>
          <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td width="1" bgcolor="#e5e5e9"></td>
              <td width="261">
            <table width="95%" border="0" cellPadding="0" cellSpacing="0" align="center">
    
    <tbody>
    {news.map(post => {
      {/* console.log(post.node.strapiId) */}
          return (
    <tr key={post.node.strapiId}>
    <td height="25" align="left" width="78%"><img src="/images/jt.gif" width="3" height="5" />&nbsp;<Link to={`/article/${post.node.slug}`} className="uk-link-reset">{post.node.title}</Link></td>
    </tr>
          )
        })}
    </tbody>
    </table>
    </td>
    <td width="1"></td>
    </tr>
    </tbody></table></td>
        </tr>
        <tr>
          <td width="263" height="1" bgcolor="#e5e5e9"></td>
        </tr>
              <tr>
          <td>&nbsp;</td>
        </tr>
      </tbody>
      </table>
      {/* 运价 */}
      <YunJia />
       {/* end运价 */}
      <table style={{marginTop: '10px'}} cellSpacing="0" cellPadding="0" width="214" border="0" align="center" background="/images/6.gif" height="200">
                <tbody>
                <tr>
                  <td height="20"></td>
                </tr>
                <tr>
                  <td>
                    <table cellSpacing="0" cellPadding="8" width="210" align="center" border="0">
                      <tbody>
                      <tr><td align="left"><LianXi /></td></tr> 
                      </tbody>
                          </table>
                          </td>
                          </tr>
                          </tbody>
                          </table>
    </td>
      {/* 右栏 */}
      <td valign="top">
      <table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
      <tbody><tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td width="669" height="37" background="/images/index_bj1.gif" style={{paddingLeft:'25px'}}>&nbsp;<span className="STYLE3">国内空运运价</span></td>
      </tr>
      <tr>
        <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
  <tbody><tr>
            <td width="1" bgcolor="#e5e5e9"></td>
    <td width="667"><table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
  <tbody><tr>
    <td><table width="580" border="0" cellSpacing="0" cellPadding="0" align="center">
  <tbody><tr>
    <td height="25" align="center">国内空运运价</td>
  </tr>
    <tr>
    <td height="25" align="center"><span className="STYLE5">以下国内空运运价仅供参考！具体运价请致电：021-62682618 021-51151242 咨询</span></td>
  </tr>
</tbody></table>
<table bordercolor="#e8e8e8" cellSpacing="0" cellPadding="0" width="580" border="1" align="center">
      <tbody>
      </tbody><tbody>
        <tr>
          <td width="16%" height="72" rowSpan="3"><p align="center"><font color="#000000">航 线</font></p></td>
          <td width="84%" colSpan="4" height="24"><p align="center"><font color="#000000">普 通 货 物 运 
            价</font></p></td>
        </tr>
        <tr>
          <td width="21%" height="24"><p align="center"><font color="#000000">基础运价</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">45公斤以上</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">100公斤以上</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">300公斤以上</font></p></td>
        </tr>
        <tr>
          <td width="21%" height="24"><p align="center"><font color="#000000">N</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">Q45</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">Q100</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">Q300</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">安庆</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">包头</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">北海</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">北京</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.5</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">长春</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">常德</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">长沙</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">成都</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">重庆</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">大连</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">丹东</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">大同</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">福州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">广州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">桂林</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">贵阳</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">海口</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">杭州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">哈尔滨</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.0</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">合肥</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">黄山</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">黄岩</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.6</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">呼和浩特</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">吉林</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">济南</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">景德镇</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.0</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">晋江</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">锦州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">九江</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">昆明</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">兰州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.0</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">拉萨</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">16.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">12.8</font></p></td>
          <td width="21%" height="24"><font color="#000000">&nbsp;&nbsp; </font></td>
          <td width="21%" height="24"><font color="#000000">&nbsp;&nbsp;&nbsp;&nbsp; </font></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">连云港</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">临沂</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.2</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">柳州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">洛阳</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">牡丹江</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">南昌</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">南京</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">南宁</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">宁波</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">青岛</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.5</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">秦皇岛</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">齐齐哈尔</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">衡州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">三亚</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">汕头</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">沙市</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">沈阳</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">深圳</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">石家庄</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">太原</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">天津</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.5</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">潍坊</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.7</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">威海</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.2</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">温州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">武汉</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.6</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">乌鲁木齐</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">13.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">11.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">9.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">武夷山</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.2</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">厦门</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">西安</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">襄攀</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">西宁</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">西双版纳</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">10.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">徐州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">廷吉</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">烟台</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">宜宾</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.5</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.1</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">宜昌</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.4</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">银川</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.1</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">义乌</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.7</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.2</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.6</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">张家界</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.3</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.0</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">湛江</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">8.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">6.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.8</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">郑州</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.8</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">3.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.9</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">舟山</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">2.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.4</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">1.2</font></p></td>
        </tr>
        <tr>
          <td width="16%" height="24"><p align="center"><font color="#000000">珠海</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">7.0</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">5.6</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.9</font></p></td>
          <td width="21%" height="24"><p align="center"><font color="#000000">4.2</font></p></td>
        </tr>
      </tbody>
    </table> </td>
  </tr>

</tbody></table>
</td>
            <td width="1" bgcolor="#e5e5e9"></td>
  </tr>
</tbody></table>
</td>
      </tr>

            <tr>
        <td width="669" height="1" bgcolor="#e5e5e9"></td>
      </tr>
    </tbody></table>     
      </td>
      {/* end 右栏 */}
    </tr>
    </tbody></table>
    </Layout>
  );
};

const query = graphql`
  query {
    strapiHomepage {
      hero {
        title
      }
      seo {
        metaTitle
        metaDescription
        shareImage {
          publicURL
        }
      }
    }
    topTenNews: allStrapiArticle(limit: 10, filter: {category: {slug: {eq: "news"}}, status: {eq: "published"}}) {
      edges {
        node {
          title
          slug
          strapiId
          publishedAt
        }
      }
    }
    allStrapiArticle(filter: { status: { eq: "published" } }) {
      edges {
        node {
          strapiId
          slug
          title
          category {
            name
          }
          image {
            childImageSharp {
              fixed(width: 800, height: 500) {
                src
                ...GatsbyImageSharpFixed
              }
            }
          }
          author {
            name
            picture {
              childImageSharp {
                fixed(width: 30, height: 30) {
                  src
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
